import AdminStudyPlans from "../../../Components/Admin/studyPlans";

export default function StudyPlanPage() {
	return <AdminStudyPlans />;
}
